<template>
    <div>
        <painting-table 
            ref="table" 
            :archived="1"
            :currentDisciplines="currentDisciplines"
            :rowChangeSelectOptions="rowChangeSelectOptions"
            :columnData="columnData"
        >
        </painting-table>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import PaintingTable from '@/components/pages/project/construction/painting/painting_table.vue';

export default {
    name: 'painting_archived',
    components: {
        PaintingTable,
    },
    props: {
        currentDisciplines: {
            type: Array,
            required: true,
        },
        rowChangeSelectOptions: {
            type: Object,
            default () {
                return null;
            },
        },
    },
    data() {
        return {
            columnData: [
                {
                    label: Vue.i18n.translate('table.crt_no'),
                    field: 'crt_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.int_no'),
                    field: 'int_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.discipline'),
                    field: 'drawing.discipline.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation'),
                    field: 'insulation',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'drawing.line.area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pipe_line'),
                    field: 'drawing.line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing'),
                    field: 'drawing.info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'drawing.page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_size'),
                    field: 'drawing.line.line_size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pipe_material'),
                    field: 'drawing.line.pipe_material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.spools'),
                    field: 'spool_nos',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.spool_amount'),
                    field: 'spool_amount',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pipe_class'),
                    field: 'drawing.line.line_class',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.work_type'),
                    field: 'work_type.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.painting_system'),
                    field: 'painting_system.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.painting_code'),
                    field: 'painting_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ral'),
                    field: 'ral.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.working_temperature'),
                    field: 'working_temperature',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.remark'),
                    field: 'remark',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.in_pdf'),
                    field: 'in_pdf',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.view_files'),
                    field: '',
                    numeric: false,
                    html: false,
                    showAddFilesButton: true,
                },
                {
                    label: Vue.i18n.translate('table.test_report'),
                    field: 'test_report',
                    numeric: false,
                    html: false,
                },
                 {
                    label: Vue.i18n.translate('table.finished'),
                    field: 'finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.closed'),
                    field: 'closed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
            ]
        }
    },
    methods: {
        onLoadTable () {
            this.$refs.table.onLoadTable();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/construction/painting/painting_archived.vue